<template>
  <v-layout>
    <div class="padding-container-sm">
      <div class="header">
        <span slot="header">
          <div class="row">
            <div class="col col-md-12 p-5 progress-view">
              <v-tab :tabProps="tabProps" v-on:activeTab="activeTab">
                <div slot="enrolled">
                  <Enroll />
                </div>
                <div slot="adherence" v-if="this.tabProps.activeTabName === 'Patient adherence'">
                  <Adherence />
                </div>
                <div slot="symptom" v-if="this.tabProps.activeTabName === 'Patient symptom'">
                  <PatientSymptoms />
                </div>
                <div slot="resolution" v-if="this.tabProps.activeTabName === 'Nurse resolution'">
                  <NurseResolution />
                </div>
              </v-tab>
            </div>
          </div>
        </span>
      </div>
    </div>
  </v-layout>
</template>

<script>
import VLayout from "@/layouts/Default.vue";
import VTab from "@/components/tab/tab.vue";
import Enroll from "@/components/reports/enroll/enroll.vue";
import PatientSymptoms from "@/components/reports/patientsymptoms/patientsymptoms.vue";
import NurseResolution from "@/components/reports/nurseresolution/nurseresolution.vue";
import Adherence from "@/components/reports/adherence/adherence.vue";

import { mapGetters } from "vuex";

export default {
  name: "reports",
  components: {
    VLayout,
    VTab,
    Enroll,
    Adherence,
    PatientSymptoms,
    NurseResolution
  },

  data() {
    return {
      tabProps: {
        tabs: [],
        activeTabName: null,
        currentUser: this.currentUser
      },
      allTabs: [
        {
          title: "Patient enrolled",
          slot: "enrolled"
        },
        {
          title: "Patient adherence",
          slot: "adherence"
        },
        {
          title: "Patient symptom",
          slot: "symptom"
        },
        {
          title: "Nurse resolution",
          slot: "resolution"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/getUser"
    })
  },
  watch: {
    currentUser: {
      immediate: true,
      handler: "onCurrentUserChange"
    }
  },
  methods: {
    activeTab(name) {
      this.tabProps.activeTabName = name;
    },
    onCurrentUserChange() {
      if (this.currentUser) {
        this.tabProps.tabs = this.allTabs;
        this.tabProps.activeTabName = this.tabProps.tabs[0].title;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
